// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  PRESUPUESTADOR_AGREGAR_PATENTE,
} from './constants';

export function agregarPatente(bool, quotation_id) {
  return {
    type: PRESUPUESTADOR_AGREGAR_PATENTE,
    data: {
      bool,
      quotation_id
    }
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case PRESUPUESTADOR_AGREGAR_PATENTE:
      return {
        ...state,
        entregaUsados: state.entregaUsados.map(usado=>{
          if(action.data.quotation_id === usado.quotation_id){
            return {
              ...usado,
              agregarPatente: action.data.bool,
              errorSetPatente: '',
              errorPeritaje: ''
            }
          } else {
            return usado
          }
        })
      };

    default:
      return state;
  }
}
